import Rating from './rating'

export default Rating
